
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.1.0
 * Query Engine version: 8d8414deb360336e4698a65aa45a1fbaf1ce13d8
 */
Prisma.prismaVersion = {
  client: "4.1.0",
  engine: "8d8414deb360336e4698a65aa45a1fbaf1ce13d8"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  email: 'email',
  hashedPassword: 'hashedPassword',
  role: 'role'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  handle: 'handle',
  hashedSessionToken: 'hashedSessionToken',
  antiCSRFToken: 'antiCSRFToken',
  publicData: 'publicData',
  privateData: 'privateData',
  userId: 'userId'
});

exports.Prisma.TokenScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  sentTo: 'sentTo',
  userId: 'userId'
});

exports.Prisma.ArticleScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createdByUserId: 'createdByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  firstPublishedAt: 'firstPublishedAt',
  firstPublishedByUserId: 'firstPublishedByUserId',
  publishedAt: 'publishedAt',
  publishedByUserId: 'publishedByUserId',
  isValid: 'isValid',
  slugEnCa: 'slugEnCa',
  titleEnCa: 'titleEnCa'
});

exports.Prisma.ArticleLocalizedScalarFieldEnum = makeEnum({
  articleId: 'articleId',
  locale: 'locale',
  slug: 'slug'
});

exports.Prisma.ArticlePageScalarFieldEnum = makeEnum({
  id: 'id',
  articleId: 'articleId',
  leadImageId: 'leadImageId',
  number: 'number'
});

exports.Prisma.ArticlePageLocalizedScalarFieldEnum = makeEnum({
  articlePageId: 'articlePageId',
  locale: 'locale',
  title: 'title',
  content: 'content',
  summary: 'summary'
});

exports.Prisma.ArticlePageViewScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  articleId: 'articleId',
  articlePageId: 'articlePageId',
  locale: 'locale'
});

exports.Prisma.BrandScalarFieldEnum = makeEnum({
  id: 'id',
  createByUserId: 'createByUserId',
  createdAt: 'createdAt',
  firstPublishedAt: 'firstPublishedAt',
  firstPublishedByUserId: 'firstPublishedByUserId',
  publishedAt: 'publishedAt',
  publishedByUserId: 'publishedByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  imageId: 'imageId',
  parentId: 'parentId',
  email: 'email',
  establishedAt: 'establishedAt',
  isValid: 'isValid',
  name: 'name',
  slug: 'slug',
  stars: 'stars',
  tickerSymbol: 'tickerSymbol',
  contactUrl: 'contactUrl',
  madeInCanadaUrl: 'madeInCanadaUrl',
  mediaKitUrl: 'mediaKitUrl',
  stockistsUrl: 'stockistsUrl',
  url: 'url',
  wikipediaUrl: 'wikipediaUrl',
  etsyUrl: 'etsyUrl',
  poshmarkUrl: 'poshmarkUrl',
  reverbUrl: 'reverbUrl',
  facebookUrl: 'facebookUrl',
  facebookId: 'facebookId',
  instagramUrl: 'instagramUrl',
  instagramId: 'instagramId',
  linkedInUrl: 'linkedInUrl',
  linkedInId: 'linkedInId',
  pinterestUrl: 'pinterestUrl',
  pinterestId: 'pinterestId',
  tikTokUrl: 'tikTokUrl',
  tikTokId: 'tikTokId',
  twitterUrl: 'twitterUrl',
  twitterId: 'twitterId',
  vimeoUrl: 'vimeoUrl',
  vimeoId: 'vimeoId',
  youTubeUrl: 'youTubeUrl',
  youTubeId: 'youTubeId',
  youTubeSlug: 'youTubeSlug',
  youTubeUserId: 'youTubeUserId',
  isEcommerceEnabled: 'isEcommerceEnabled',
  isGoDaddy: 'isGoDaddy',
  isLightspeed: 'isLightspeed',
  isShopify: 'isShopify',
  isSquare: 'isSquare',
  isSquarespace: 'isSquarespace',
  isWix: 'isWix',
  isWordpress: 'isWordpress',
  isCanadianAssembled: 'isCanadianAssembled',
  isCanadianDesigned: 'isCanadianDesigned',
  isCanadianManufactured: 'isCanadianManufactured',
  isCanadianOperated: 'isCanadianOperated',
  isCanadianOwned: 'isCanadianOwned',
  isCanadianSourced: 'isCanadianSourced',
  hasAffiliateProgram: 'hasAffiliateProgram',
  hasGiftboxes: 'hasGiftboxes',
  hasGiftcards: 'hasGiftcards',
  hasRewardsProgram: 'hasRewardsProgram',
  hasSubscriptions: 'hasSubscriptions',
  isAddressOnFacebook: 'isAddressOnFacebook',
  isAddressOnGoogle: 'isAddressOnGoogle',
  isAddressOnSite: 'isAddressOnSite',
  isFrenchOnly: 'isFrenchOnly',
  showPlacePhotos: 'showPlacePhotos',
  isCertifiedBCorporation: 'isCertifiedBCorporation',
  isCertifiedWomenOwned: 'isCertifiedWomenOwned'
});

exports.Prisma.BrandLocalizedScalarFieldEnum = makeEnum({
  brandId: 'brandId',
  locale: 'locale',
  content: 'content',
  summary: 'summary'
});

exports.Prisma.BrandViewScalarFieldEnum = makeEnum({
  id: 'id',
  brandId: 'brandId',
  createdAt: 'createdAt',
  locale: 'locale'
});

exports.Prisma.BrandCrawlScalarFieldEnum = makeEnum({
  id: 'id',
  brandId: 'brandId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  source: 'source',
  error: 'error',
  url: 'url'
});

exports.Prisma.CategoryScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createByUserId: 'createByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  publishedAt: 'publishedAt',
  publishedByUserId: 'publishedByUserId',
  parentId: 'parentId',
  idPath: 'idPath',
  isValid: 'isValid',
  name: 'name'
});

exports.Prisma.CategoryLocalizedScalarFieldEnum = makeEnum({
  categoryId: 'categoryId',
  locale: 'locale',
  name: 'name',
  namePath: 'namePath',
  slug: 'slug',
  slugPath: 'slugPath'
});

exports.Prisma.CategoryViewScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  categoryId: 'categoryId',
  locale: 'locale'
});

exports.Prisma.CityScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createdByUserId: 'createdByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  provinceAlphaCode: 'provinceAlphaCode',
  name: 'name',
  slug: 'slug'
});

exports.Prisma.FeedbackScalarFieldEnum = makeEnum({
  id: 'id',
  comments: 'comments',
  company: 'company',
  email: 'email',
  name: 'name',
  url: 'url'
});

exports.Prisma.ImageScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isValid: 'isValid',
  extension: 'extension',
  hash: 'hash',
  md5: 'md5',
  mimeType: 'mimeType',
  name: 'name',
  size: 'size',
  path: 'path',
  url: 'url',
  height: 'height',
  width: 'width',
  tags: 'tags',
  isGrayscale: 'isGrayscale',
  accentColor: 'accentColor',
  dominantColorForeground: 'dominantColorForeground',
  dominantColorBackground: 'dominantColorBackground',
  dominantColors: 'dominantColors',
  brandId: 'brandId'
});

exports.Prisma.ImageLocalizedScalarFieldEnum = makeEnum({
  imageId: 'imageId',
  locale: 'locale',
  alternateText: 'alternateText'
});

exports.Prisma.ImageVariantScalarFieldEnum = makeEnum({
  id: 'id',
  imageId: 'imageId',
  extension: 'extension',
  formatVariant: 'formatVariant',
  height: 'height',
  md5: 'md5',
  mimeType: 'mimeType',
  path: 'path',
  size: 'size',
  url: 'url',
  width: 'width',
  widthVariant: 'widthVariant'
});

exports.Prisma.LocationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  brandId: 'brandId',
  stockistId: 'stockistId',
  restaurantId: 'restaurantId',
  cityId: 'cityId',
  street: 'street',
  streetNumber: 'streetNumber',
  unitNumber: 'unitNumber',
  postalCode: 'postalCode',
  formatted: 'formatted',
  name: 'name',
  title: 'title',
  latitude: 'latitude',
  longitude: 'longitude',
  isPrimary: 'isPrimary',
  isPrimaryOfType: 'isPrimaryOfType',
  type: 'type',
  place_id: 'place_id'
});

exports.Prisma.PrivacyPolicyScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createByUserId: 'createByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId'
});

exports.Prisma.PrivacyPolicyLocalizedScalarFieldEnum = makeEnum({
  privacyPolicyId: 'privacyPolicyId',
  locale: 'locale',
  content: 'content'
});

exports.Prisma.ProvinceScalarFieldEnum = makeEnum({
  alphaCode: 'alphaCode',
  createdAt: 'createdAt',
  createByUserId: 'createByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  regionId: 'regionId',
  name: 'name',
  slug: 'slug'
});

exports.Prisma.RegionScalarFieldEnum = makeEnum({
  id: 'id',
  createByUserId: 'createByUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  name: 'name',
  slug: 'slug'
});

exports.Prisma.RestaurantScalarFieldEnum = makeEnum({
  id: 'id',
  createByUserId: 'createByUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  name: 'name',
  slug: 'slug',
  url: 'url'
});

exports.Prisma.SearchScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  locale: 'locale',
  term: 'term'
});

exports.Prisma.StockistScalarFieldEnum = makeEnum({
  id: 'id',
  createByUserId: 'createByUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  publishedAt: 'publishedAt',
  publishedByUserId: 'publishedByUserId',
  firstPublishedAt: 'firstPublishedAt',
  firstPublishedByUserId: 'firstPublishedByUserId',
  brandsUrl: 'brandsUrl',
  brandsUrlBrandSelector: 'brandsUrlBrandSelector',
  canadianBrandsUrl: 'canadianBrandsUrl',
  canadianBrandsUrlBrandSelector: 'canadianBrandsUrlBrandSelector',
  contactUrl: 'contactUrl',
  email: 'email',
  hasAffiliateProgram: 'hasAffiliateProgram',
  isValid: 'isValid',
  name: 'name',
  slug: 'slug',
  url: 'url',
  isCanadianOwned: 'isCanadianOwned',
  hasCanadianBrandList: 'hasCanadianBrandList',
  facebookUrl: 'facebookUrl',
  facebookId: 'facebookId',
  instagramUrl: 'instagramUrl',
  instagramId: 'instagramId',
  linkedInUrl: 'linkedInUrl',
  linkedInId: 'linkedInId',
  pinterestUrl: 'pinterestUrl',
  pinterestId: 'pinterestId',
  tikTokUrl: 'tikTokUrl',
  tikTokId: 'tikTokId',
  twitterUrl: 'twitterUrl',
  twitterId: 'twitterId',
  vimeoUrl: 'vimeoUrl',
  vimeoId: 'vimeoId',
  youTubeUrl: 'youTubeUrl',
  youTubeId: 'youTubeId',
  youTubeSlug: 'youTubeSlug',
  youTubeUserId: 'youTubeUserId'
});

exports.Prisma.StockistCrawlScalarFieldEnum = makeEnum({
  id: 'id',
  stockistId: 'stockistId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  source: 'source',
  error: 'error',
  url: 'url'
});

exports.Prisma.TagScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createByUserId: 'createByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId',
  publishedAt: 'publishedAt',
  publishedByUserId: 'publishedByUserId',
  isValid: 'isValid',
  name: 'name'
});

exports.Prisma.TagLocalizedScalarFieldEnum = makeEnum({
  tagId: 'tagId',
  name: 'name',
  locale: 'locale',
  slug: 'slug'
});

exports.Prisma.TagViewScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  tagId: 'tagId',
  locale: 'locale'
});

exports.Prisma.TermsOfUseScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createByUserId: 'createByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId'
});

exports.Prisma.TermsOfUseLocalizedScalarFieldEnum = makeEnum({
  termsOfUseId: 'termsOfUseId',
  locale: 'locale',
  content: 'content'
});

exports.Prisma.AboutUsScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  createByUserId: 'createByUserId',
  updatedAt: 'updatedAt',
  updatedByUserId: 'updatedByUserId'
});

exports.Prisma.AboutUsLocalizedScalarFieldEnum = makeEnum({
  aboutUsId: 'aboutUsId',
  locale: 'locale',
  content: 'content'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});
exports.LocaleD = makeEnum({
  en_ca: 'en_ca',
  fr_ca: 'fr_ca'
});

exports.ProvinceAlphaCode = makeEnum({
  AB: 'AB',
  BC: 'BC',
  MB: 'MB',
  NB: 'NB',
  NL: 'NL',
  NS: 'NS',
  NT: 'NT',
  NU: 'NU',
  ON: 'ON',
  PE: 'PE',
  QC: 'QC',
  SK: 'SK',
  YT: 'YT'
});

exports.ImageFormatVariant = makeEnum({
  Jpg: 'Jpg',
  Webp: 'Webp',
  Svg: 'Svg'
});

exports.ImageWidthVariant = makeEnum({
  W100: 'W100',
  W200: 'W200',
  W300: 'W300',
  W500: 'W500',
  W750: 'W750',
  W1000: 'W1000',
  W1500: 'W1500',
  W2000: 'W2000'
});

exports.LocationType = makeEnum({
  Unspecified: 'Unspecified',
  Adminstrative: 'Adminstrative',
  Production: 'Production',
  Restaurant: 'Restaurant',
  Retail: 'Retail',
  Service: 'Service',
  Unknown: 'Unknown'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Session: 'Session',
  Token: 'Token',
  Article: 'Article',
  ArticleLocalized: 'ArticleLocalized',
  ArticlePage: 'ArticlePage',
  ArticlePageLocalized: 'ArticlePageLocalized',
  ArticlePageView: 'ArticlePageView',
  Brand: 'Brand',
  BrandLocalized: 'BrandLocalized',
  BrandView: 'BrandView',
  BrandCrawl: 'BrandCrawl',
  Category: 'Category',
  CategoryLocalized: 'CategoryLocalized',
  CategoryView: 'CategoryView',
  City: 'City',
  Feedback: 'Feedback',
  Image: 'Image',
  ImageLocalized: 'ImageLocalized',
  ImageVariant: 'ImageVariant',
  Location: 'Location',
  PrivacyPolicy: 'PrivacyPolicy',
  PrivacyPolicyLocalized: 'PrivacyPolicyLocalized',
  Province: 'Province',
  Region: 'Region',
  Restaurant: 'Restaurant',
  Search: 'Search',
  Stockist: 'Stockist',
  StockistCrawl: 'StockistCrawl',
  Tag: 'Tag',
  TagLocalized: 'TagLocalized',
  TagView: 'TagView',
  TermsOfUse: 'TermsOfUse',
  TermsOfUseLocalized: 'TermsOfUseLocalized',
  AboutUs: 'AboutUs',
  AboutUsLocalized: 'AboutUsLocalized'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
